<template>
  <component :is="type === 'fixed' ? Teleport : 'div'" v-if="isCN" to="body">
    <div :class="['x-attract flex justify-center items-center', { fixed: type === 'fixed' }]">
      <ContactQRcode
        :style="{ width: '100px', height: '100px' }"
        :size="100"
        class="qrcode"
        :source_from="'youyan'"
        :code="code"
        source_from="youyan"
      />
      <div class="words ml-[12px]">
        <div class="title">{{ $t('sao-yi-sao') }}</div>
        <div class="desc">{{ $t('huo-qu-zui-xin-zi-xun-fu-li') }}</div>
      </div>
    </div>
  </component>
</template>

<script setup lang="ts">
import { PositionCode } from '@rendora/common/features/contact';
import ContactQRcode from '@rendora/common/features/contact/ui/Qrcode.vue';
import { getGlobalConfig } from '@rendora/common/utils/config';
import { Teleport } from 'vue';

const { isCN } = getGlobalConfig();

const code = PositionCode['有言官网-付费订阅-咨询定制']; // @xi18n-ignore

enum AttractSource {
  EXCHANGE = 'exchange2',
  PAYMENT = 'payment2',
  REGISTER = 'register2',
  TASTE_REGISTER = 'taste-register',
  PERSON_PAYMENT = 'person-payment',
  TEAM_PAYMENT = 'team-payment2',
}

const props = withDefaults(
  defineProps<{
    source?: AttractSource;
    url?: string;
    type?: 'inline' | 'fixed';
  }>(),
  {
    type: 'inline',
  },
);
</script>

<style lang="scss" scoped>
.title {
  color: var(--x-text-1);
  font-weight: var(--x-weight-medium);
  line-height: 24px;
}
.desc {
  color: var(--x-text-1-60);
}
.fixed {
  background: #ffffff;
  box-shadow: var(--x-shadow);
  border-radius: var(--x-radius-large);
  padding: 24px;
  position: fixed;
  left: 20px;
  bottom: 320px;
}
.qrcode {
  width: 100px;
  height: 100px;
  margin: 0 !important;
  img {
    width: 100% !important;
    height: 100% !important;
  }
}
.words {
  margin-top: 6px;
  line-height: 18px;
  font-size: 14px;
}
</style>
